import React from "react";
import {
  formatDate,
  formatPaymentPeriod,
  transformPaymentNumbers,
} from "../../../../../../helpers/annuity-payment";
import { messages } from "../../../../../../helpers/messages";

const PaymentScheduleTable = ({ calculationResult, amountError, isHybrid }) => {
  const { payments, refundAmount, overpaymentTotal, amount } = calculationResult;
  const formatedPeyments = transformPaymentNumbers(payments);
  const hybridNumbering = (dealAmount, number, index) => !Number(dealAmount) ? parseInt(number) : index
  const isErrorInterestLimit = amountError === messages[20002]

  const renderPayments = () =>
    formatedPeyments.map(
      (
        { paymentAmount, paymentDate, dateFrom, dateTo, dealAmount, overpaymentAmount, dealAmountRemains, number },
        index
      ) => (
        <tr key={index} align="center" className={`${isHybrid && index === 0 ? 'firstPayment' : undefined}`}>
          <th scope="row">
            {isHybrid ? hybridNumbering(dealAmount, number, index) : parseInt(number)}
          </th>
          <th scope="row" className="nowrap">
            {`${formatPaymentPeriod(dateFrom, dateTo)}`}
          </th>
          <th scope="row">
            {formatDate(paymentDate)}
          </th>
          <td>{paymentAmount}</td>
          <td>{dealAmount}</td>
          <td>{overpaymentAmount}</td>
          <td>{dealAmountRemains}</td>
        </tr>
      )
    );

  return (
    <div className="form-element calculationLayout-payment">
      <table className="table hover">
        <thead>
          <tr>
            <th rowSpan={2} scope="col">Номер платежа</th>
            <th rowSpan={2}>Период пользования микрозаймом</th>
            <th rowSpan={2}>Срок платежа (не позднее указанной даты)</th>
            <th rowSpan={2}>
                Сумма платежа, бел. руб.
            </th>
            <th scope="col" colSpan={2} align="center">
              В том числе
            </th>
            <th rowSpan={2}>Остаток суммы микрозайма, бел. руб.</th>
          </tr>
          <tr>
            <th scope="col">погашение микрозайма, бел. руб</th>
            <th scope="col">уплата процентов, бел. руб.</th>
          </tr>
        </thead>
        <tbody>{payments && !isErrorInterestLimit && renderPayments()}</tbody>
        <tfoot>
          <tr align="center">
            <td align="left">Итого:</td>
            <td></td>
            <td></td>
            <td>{refundAmount}</td>
            <td>{amount || 0}</td>
            <td>{overpaymentTotal}</td>
            <td>-</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default PaymentScheduleTable;
